import {
  formatContact,
  formatDressCode,
  formatHourlyRate,
  formatTemplateAddress,
  formatTemplateContact,
  formatTemplateList,
  formatTemplateRate,
  formatTemplateTasks,
  formatTemplateTools,
  getTemplateQualification,
  getTemplateTitle,
  orNone,
} from './missionTemplateFormat';
import { formatRiskyPositions } from './missionTemplateRiskyPositions';
import { buildTemplateTasks, normalizePenibilite } from './templateFormData';
import { templateText } from './templateTexts';

// Same rows, same order and same wording as the company summary; stepKey is
// the wizard step that owns the field.
export const SUMMARY_ROWS = [
  { key: 'name', stepKey: 'activity' },
  { key: 'activity', stepKey: 'activity' },
  { key: 'qualification', stepKey: 'activity' },
  { key: 'riskyPosition', stepKey: 'risk' },
  { key: 'tools', stepKey: 'prerequis' },
  { key: 'licences', stepKey: 'prerequis' },
  { key: 'languages', stepKey: 'prerequis' },
  { key: 'dressCode', stepKey: 'prerequis' },
  { key: 'address', stepKey: 'locationSalary' },
  { key: 'salary', stepKey: 'locationSalary' },
  { key: 'contact', stepKey: 'locationSalary' },
  { key: 'tasks', stepKey: 'tasks' },
].map((row) => ({ ...row, label: templateText(`summary.${row.key}`) }));

/** The summary of the template being filled in the wizard. */
export const buildTemplateSummary = (form, riskyPositions) => ({
  name: form?.name,
  activity: form?.activity,
  qualification: form?.qualificationLabel,
  riskyPosition: formatRiskyPositions(
    {
      position_at_risk: !!form?.position_at_risk,
      penibilite: form?.position_at_risk
        ? normalizePenibilite(form?.penibilite)
        : {},
    },
    riskyPositions
  ),
  tools: orNone(formatTemplateTools(form?.tools)),
  licences: orNone(formatTemplateList(form?.licences)),
  languages: orNone(formatTemplateList(form?.languages)),
  dressCode: formatDressCode(form?.dressCode),
  address: formatTemplateAddress(form?.location),
  salary: formatHourlyRate(form?.salary, !!form?.isIndexedToMinimumWage),
  contact: formatContact(form?.contact_name, form?.contact_poste),
  tasks: formatTemplateTasks(form ? buildTemplateTasks(form) : []),
});

/** The summary of a template the API returned. */
export const buildTemplateSummaryFromApi = (template, riskyPositions) => ({
  name: getTemplateTitle(template),
  activity: template?.activity,
  qualification: getTemplateQualification(template),
  riskyPosition: formatRiskyPositions(template?.conditions, riskyPositions),
  tools: orNone(formatTemplateTools(template?.tools)),
  licences: orNone(formatTemplateList(template?.licences)),
  languages: orNone(formatTemplateList(template?.language)),
  dressCode: formatDressCode(template?.dressCode),
  address: formatTemplateAddress(template?.location),
  salary: formatTemplateRate(template),
  contact: formatTemplateContact(template),
  tasks: formatTemplateTasks(template?.tasks),
});
